/**
 * The business events that change a party's economic obligation on a contract. Each type maps
 * to one of the epic's required lifecycle events. The warranty's own Warranty.Status remains
 * the lifecycle source of truth — an allocation only records that event's financial effect.
 */
export enum AllocationType {
  /** The original sale — creates the obligations a contract's components describe. */
  SALE = 'SALE',
  /** A cancellation (free-look or prorated) — reduces or reverses a prior obligation. */
  CANCEL = 'CANCEL',
  /** Reversing a prior cancellation — restores an obligation. */
  REINSTATE = 'REINSTATE',
  /**
   * Any other change to an obligation — a re-rate, a correction, a fee waiver — that isn't a
   * sale, cancellation, or reinstatement.
   */
  ADJUSTMENT = 'ADJUSTMENT',
  /**
   * The contract is nullified outright (Warranty.Status.VOID) — every party's net obligation to
   * date is reversed to zero, not just prorated like a CANCEL. Distinct from CANCEL because a
   * void can follow an existing cancellation (a warranty may be voided from any non-VOID status),
   * so it must be able to zero out a party that a prior CANCEL already partially reduced, not
   * just reverse the original SALE share again.
   */
  VOID = 'VOID',
}
